export default "__VITE_ASSET__BY$xwlBn__"